/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Webhooks12(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Webhooks12',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M8.04 1.364a2.714 2.714 0 0 1-.274 3.85L9.814 8.76a.5.5 0 1 1-.866.5L6.671 5.318a.5.5 0 0 1 .228-.706 1.714 1.714 0 1 0-2.61-1.57l-.032.498-.998-.065.032-.499A2.714 2.714 0 0 1 8.04 1.364M6.528 3.238a.5.5 0 0 0-.866-.5L3.614 6.286a2.714 2.714 0 1 0 .3 4.993l.448-.22-.442-.898-.448.221a1.714 1.714 0 1 1 .053-3.046.5.5 0 0 0 .726-.155L6.53 3.238zm1.717 8.115a2.714 2.714 0 0 0 2.546-4.764l-.415-.277-.556.831.416.278a1.714 1.714 0 1 1-2.665 1.474.5.5 0 0 0-.498-.55H2.521a.5.5 0 0 0 0 1h4.097a2.71 2.71 0 0 0 1.628 2.008z","fill":"currentColor"}))
}
